
import { cn, Spinner } from '@lensora/ui'
import { BarChart3, Building2, LayoutDashboard, Users } from 'lucide-react'
import { Navigate, NavLink, Outlet } from 'react-router-dom'

import { useIsLensoraAdmin } from '@/hooks/use-is-lensora-admin'
import { useMe } from '@/hooks/use-me'

const navItems = [
  { to: '/admin', end: true, icon: LayoutDashboard, label: 'Overview' },
  { to: '/admin/tenants', end: false, icon: Building2, label: 'Tenants' },
  { to: '/admin/users', end: false, icon: Users, label: 'Users' },
  { to: '/admin/usage', end: false, icon: BarChart3, label: 'Usage' },
]

export function AdminLayout() {
  const { isLoading } = useMe()
  const isAdmin = useIsLensoraAdmin()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (!isAdmin) return <Navigate to="/dashboard" replace />

  return (
    <div className="flex h-screen bg-surface-raised">
      <aside className="flex h-full w-52 flex-col border-r border-border bg-surface">
        <div className="flex h-16 items-center gap-2 px-4 border-b border-border">
          <div className="h-6 w-6 rounded bg-brand-primary" />
          <span className="text-sm font-semibold text-text">Lensora Admin</span>
        </div>
        <nav className="flex-1 space-y-1 p-3">
          {navItems.map(({ to, end, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-brand-primary text-brand-primary-foreground font-medium'
                    : 'text-text-muted hover:bg-surface-raised hover:text-text'
                )
              }
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3">
          <NavLink
            to="/dashboard"
            className="flex items-center gap-2 rounded px-3 py-2 text-xs text-text-muted hover:text-text transition-colors"
          >
            ← Back to dashboard
          </NavLink>
        </div>
      </aside>

      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  )
}
